import { SortFilter } from '../../generated/maya.types';

const SORT_LABELS: Partial<Record<SortFilter, string>> = {
  [SortFilter.NEWEST]: 'Sort by newest',
  [SortFilter.OLDEST]: 'Sort by oldest',
};

const sortFilterLimitedOptions = Object.values(SortFilter)
  .filter((value) => SORT_LABELS[value])
  .map((value) => ({
    id: value,
    label: SORT_LABELS[value] || '',
  }));

export default sortFilterLimitedOptions;
